module.exports = __webpack_public_path__ + "static/media/background-len.59e25358.jpg";